// User listing
export const GET_SUBSCRIBER_LIST = "GET_SUBSCRIBER_LIST";
export const GET_SUBSCRIBER_LIST_SUCCESS = "GET_SUBSCRIBER_LIST_SUCCESS";
export const GET_SUBSCRIBER_LIST_ERROR = "GET_SUBSCRIBER_LIST_ERROR";
